export default "__VITE_ASSET__Dax1ZTET__"